import { FC } from 'react'
import { AppHead } from 'client/components/Layout/components/AppHead/AppHead'
import { useTranslation } from 'react-i18next'
import { ClientLocaleNS } from 'lib/constants/locales'
import { PolicyddaPageContent } from 'client/contents/PolicyddaPageContent/PolicyddaageContent'

type TProps = {}

const PrivacyPage: FC<TProps> = () => {
  const { t } = useTranslation(ClientLocaleNS.PolicyddaPage)
  return (
    <article className="bg-surface-white flex h-full w-full flex-col">
      <AppHead title={t('title')} />
      <PolicyddaPageContent />
    </article>
  )
}

export default PrivacyPage
